import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonLoader = ({ type = "default" }) => {
  if (type === "plans") {
    return (
      <SkeletonTheme baseColor="#707070ff" highlightColor="#a09f9fff">
      <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <h4 className="page-title lh-1 mb-3">
                  <Skeleton width={150} height={30} />
                </h4>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xxl-10">
              <div className="text-center mb-3">
                <h1><Skeleton width={300} height={40} /></h1>
                <p><Skeleton width={250} height={20} /></p>
              </div>

              <div className="row my-3">
                {[1, 2, 3].map((_, i) => (
                  <div className="col-md-4" key={i}>
                    <div className="card">
                      <div className="card-body text-center">
                        <Skeleton height={30} width={100} className="mb-2" />
                        <Skeleton height={30} width={140} className="mb-2" />
                        <Skeleton height={20} width={180} className="mb-2" />
                        <Skeleton height={40} width={150} className="mt-2 mb-3" />

                        <ul className="list-unstyled d-grid gap-2 text-start mt-3">
                          {Array.from({ length: 5 }).map((_, index) => (
                            <li key={index}>
                              <Skeleton height={20} />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Skeleton for Comparison Table */}
              <div className="row mb-4 px-1">
                <div className="card py-3 px-0">
                  <h3 className="mb-3 text-center"><Skeleton width={200} /></h3>
                  <div className="table-responsive-sm">
                    <table className="table table-hover table-centered mb-0 text-center fw-bold table-bordered">
                      <thead className="table-active">
                        <tr>
                          <th><Skeleton width={80} /></th>
                          {[1, 2, 3].map((_, i) => (
                            <th key={i}>
                              <div className="text-center">
                                <Skeleton height={25} width={80} className="mb-2" />
                                <Skeleton height={20} width={100} />
                                <Skeleton height={40} width={120} className="mt-2" />
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {Array.from({ length: 10 }).map((_, rowIndex) => (
                          <tr key={rowIndex}>
                            <td><Skeleton width={100} /></td>
                            {[1, 2, 3].map((_, colIndex) => (
                              <td key={colIndex}><Skeleton width={60} /></td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </SkeletonTheme>
    );
  }

  if (type === "dashboard") {
    return (
      <SkeletonTheme baseColor="#707070ff" highlightColor="#a09f9fff">
       <div className="content-page">
      <div className="content">
        <div className="container-fluid">

          {/* Page Title and Filters */}
          <div className="row">
            <div className="col-12">
              <div className="page-title-box">
                <div className="page-title-right d-flex align-items-center gap-2">
                  <Skeleton height={38} width={250} />
                  <Skeleton height={38} width={100} />
                  <Skeleton height={38} width={150} />
                  <Skeleton height={38} width={30} />
                  <Skeleton height={38} width={150} />
                </div>
                <h4 className="page-title"><Skeleton width={200} /></h4>
              </div>
            </div>
          </div>

          {/* Total Call Minutes Cards */}
          <div className="row mb-3">
            <h4 className="text-green"><Skeleton width={200} /></h4>

            {[...Array(4)].map((_, i) => (
              <div key={i} className="col-xl-3 col-lg-6">
                <div className="card cta-box overflow-hidden">
                  <div className="card-body pb-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h3 className="mt-0 cta-box-title mb-1">
                          <Skeleton width={150} />
                        </h3>
                        <h2 className="my-2 py-1 cta-box-title">
                          <Skeleton width={80} height={30} />
                        </h2>
                      </div>
                      <Skeleton circle width={60} height={60} />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Performance Score Charts */}
          <div className="row mb-3">
            <h4 className="text-green"><Skeleton width={200} /></h4>

            {[...Array(3)].map((_, i) => (
              <div key={i} className="col-xl-4 col-lg-12">
                <div className="card">
                  <div className="d-flex card-header justify-content-between align-items-center pb-0">
                    <h4 className="header-title"><Skeleton width={180} /></h4>
                  </div>
                  <div className="card-body pt-0">
                    <Skeleton height={180} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Call Insights */}
          <div className="row">
            <h4 className="text-green"><Skeleton width={200} /></h4>

            {[...Array(3)].map((_, i) => (
              <div key={i} className="col-xl-4 col-lg-12">
                <div className="card">
                  <div className="d-flex card-header justify-content-between align-items-center pb-0">
                    <h4 className="header-title"><Skeleton width={200} /></h4>
                  </div>
                  <div className="card-body pt-0 px-1">
                    <Skeleton height={180} />
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
        </div>
        </SkeletonTheme>
    );
  }

  if (type === "login") {
    return (
      <SkeletonTheme baseColor="#707070ff" highlightColor="#a09f9fff">
      <div className="auth-fluid">
        {/* Left content */}
        <div className="auth-fluid-form-box">
          <div className="card-body d-flex flex-column h-100 gap-3">

            {/* Logo */}
            <div className="auth-brand text-center text-lg-start">
              <Skeleton height={70} width={150} />
            </div>

            <div className="my-auto">
              <h3 className="mt-0"><Skeleton width={100} /></h3>
              <p className="mb-4"><Skeleton width={`80%`} /></p>

              {/* Form */}
              <form>
                <div className="mb-3">
                  <label className="form-label"><Skeleton width={120} /></label>
                  <Skeleton height={40} />
                </div>

                <div className="mb-3">
                  <div className="float-end">
                    <Skeleton width={100} />
                  </div>
                  <label className="form-label"><Skeleton width={100} /></label>
                  <Skeleton height={40} />
                </div>

                <div className="mb-3">
                  <Skeleton width={140} height={20} />
                </div>

                <div className="d-grid mb-0 text-center">
                  <Skeleton height={45} />
                </div>

                <div className="text-center mt-4">
                  <p className="fs-16"><Skeleton width={120} /></p>
                  <div className="d-flex justify-content-center gap-3">
                    <Skeleton circle height={40} width={40} />
                    <Skeleton circle height={40} width={40} />
                    <Skeleton circle height={40} width={40} />
                    <Skeleton circle height={40} width={40} />
                  </div>
                </div>
              </form>
            </div>

            {/* Footer */}
            <footer className="footer footer-alt text-center">
              <Skeleton width={200} />
            </footer>
          </div>
        </div>

        {/* Right side carousel content */}
        <div className="auth-fluid-right text-center p-4">
          <div className="auth-user-testimonial">
            <Skeleton height={40} width={`60%`} style={{ margin: '0 auto' }} />
            <Skeleton count={3} width={`80%`} style={{ margin: '0 auto' }} />
            <Skeleton width={100} style={{ margin: '10px auto 0' }} />
          </div>
        </div>
      </div>
       </SkeletonTheme>
    );
  };
  if (type === "settings") {
    return (
      <SkeletonTheme baseColor="#707070ff" highlightColor="#a09f9fff">
          <div className="content">
      <div className="container-fluid">
        <div className="row mb-3">
          <div className="col-xl-4 col-lg-5">
            <div className="card text-center h-100">
              <div className="card-header text-start pb-0">
                <Skeleton height={20} width={150} />
                <Skeleton height={12} width={250} />
              </div>
              <div className="card-body pt-2">
                <Skeleton circle height={80} width={80} className="mx-auto mb-2" />
                <Skeleton height={20} width={120} className="mb-1 mx-auto" />
                <Skeleton height={14} width={80} className="mb-2 mx-auto" />
                <Skeleton height={30} width={150} className="mb-2 mx-auto" />
                <Skeleton height={12} width={180} className="mb-3 mx-auto" />
                <Skeleton height={20} width={180} className="mb-1 mx-auto" />
                <Skeleton count={4} height={40} className="mb-2" />
                <Skeleton height={40} width={120} className="mt-3 float-end" />
              </div>
            </div>
          </div>

          <div className="col-xl-8 col-lg-5">
            <div className="card h-100">
              <div className="card-header text-start pb-0">
                <Skeleton height={20} width={200} />
              </div>
              <div className="card-body pt-2">
                {/* Notification section */}
                <Skeleton height={20} width={180} className="mb-2" />
                <Skeleton count={3} height={80} className="mb-3" />

                {/* Account Security */}
                <Skeleton height={20} width={200} className="mb-2" />
                <Skeleton height={12} width={300} className="mb-2" />
                <Skeleton count={3} height={40} className="mb-2" />
                <Skeleton height={80} className="mb-3" />

                {/* Privacy Settings */}
                <Skeleton height={20} width={180} className="mb-2" />
                <Skeleton height={12} width={280} className="mb-2" />
                <Skeleton height={80} className="mb-2" />

                <Skeleton height={40} width={120} className="float-end mt-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
       </SkeletonTheme>
    );
  };


  // default skeleton (table style)
  return (
    <div className="container">
      {/* Header Card Skeleton */}
      <div className="card mb-3">
        <div className="card-header p-2">
          <div className="d-flex align-items-center justify-content-between">
            <Skeleton height={30} width={180} />
            <div className="d-flex align-items-center">
              <Skeleton circle width={50} height={50} />
              <div className="ms-2">
                <Skeleton height={20} width={120} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Card Skeleton */}
      <div className="card">
        {/* Search and Date Filters */}
        <div className="card-header border-bottom d-flex flex-wrap justify-content-between gap-2 p-3">
          <div>
            <Skeleton height={38} width={200} />
          </div>
          <div className="d-flex gap-2">
            <Skeleton height={38} width={160} />
            <Skeleton height={38} width={160} />
            <Skeleton height={38} width={80} />
          </div>
        </div>

        {/* Table Header */}
        <div className="table-responsive">
          <table className="table mb-0">
            <thead className="bg-light-subtle">
              <tr>
                {[...Array(10)].map((_, i) => (
                  <th key={i} className="py-2">
                    <Skeleton height={20} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(8)].map((_, i) => (
                <tr key={i}>
                  {[...Array(10)].map((_, j) => (
                    <td key={j}>
                      <Skeleton height={j === 8 || j === 9 ? 32 : 20} width={j === 8 || j === 9 ? 100 : "100%"} />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Skeleton */}
        <div className="card-footer">
          <div className="d-flex justify-content-end">
            <Skeleton height={35} width={250} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoader;
